document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth <= 767) {  // Check if on mobile
    let items = document.querySelectorAll('.review-slide-item');
    let currentIndex = 0;

    function showSlide(index) {
      items.forEach((item, i) => {
        item.style.display = i === index ? 'block' : 'none';
      });
    }

    function nextSlide() {
      currentIndex = (currentIndex + 1) % items.length;
      showSlide(currentIndex);
    }

    setInterval(nextSlide, 3000); // Change slide every 3 seconds
    showSlide(currentIndex);  // Initialize with the first slide
  }
});
